import React from 'react';

const Footer = () => {
  return (
    <>
      <footer class="align-items-center d-flex">
        <div class="container d-flex justify-content-center align-items-center">
          <div class="sosmed">
            <div class="icon text-center">
              <i class="fab fa-instagram "></i>
              <i
                class="fab fa-facebook me-2
               ms-2
              "
              ></i>
              <i class="fab fa-dribbble "></i>
            </div>
            <p>&copy; copyright 2021 | Donny Marsahid</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
